"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateServiceDefinitionSchema = exports.serviceDefinitionSchema = void 0;
const zod_1 = require("zod");
const enums_js_1 = require("../enums.js");
const localDate_js_1 = require("../localDate.js");
exports.serviceDefinitionSchema = zod_1.z.object({
    serviceType: zod_1.z.enum(enums_js_1.ServiceTypes),
    displayName: zod_1.z.string().min(1),
    kind: zod_1.z.enum(enums_js_1.ApptKinds),
    durationMin: zod_1.z.number().int().min(5).max(480),
    allowedRoles: zod_1.z.array(zod_1.z.enum(enums_js_1.ProviderRoles)),
    allowedPlaces: zod_1.z.array(zod_1.z.enum(enums_js_1.PlacesOfService)),
    defaultFrequency: zod_1.z.enum(['WEEKLY', 'AS_NEEDED']),
    groupMaxClients: zod_1.z.number().int().positive().nullable().optional(),
    defaultStartMin: localDate_js_1.timeMinSchema.nullable().optional(),
    defaultEndMin: localDate_js_1.timeMinSchema.nullable().optional(),
    defaultDays: zod_1.z.array(zod_1.z.enum(enums_js_1.DayOfWeeks)),
    bundleHints: zod_1.z.array(zod_1.z.enum(enums_js_1.ServiceTypes)),
    telehealthAllowed: zod_1.z.boolean().optional(),
    active: zod_1.z.boolean().optional(),
});
exports.updateServiceDefinitionSchema = exports.serviceDefinitionSchema.partial().omit({
    serviceType: true,
});
//# sourceMappingURL=service.js.map